import { render, staticRenderFns } from "./policy-center.vue?vue&type=template&id=56024b84&scoped=true&"
import script from "./policy-center.vue?vue&type=script&lang=js&"
export * from "./policy-center.vue?vue&type=script&lang=js&"
import style0 from "./policy-center.vue?vue&type=style&index=0&id=56024b84&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.9.8@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56024b84",
  null
  
)

export default component.exports